export enum FolderMenu {
  showFolder,
  deactivateFolder,
  deleteFolder,
  showAgent
}
